export default {"src":"/_next/static/media/telegram_icon.231c094c.svg","height":40,"width":40};